module.exports = __webpack_public_path__ + "media/images/notification-f6839ecba272a82ac624d72f2b48ff4f.png";